// local IP
// const URL = "http://192.168.1.176:4001/v1";

// server ip
const URL = `https://api.ueducatetelangana.com/v1`;

const KpostApiUrl = `https://devapi2.kpostindia.com/v2`;

const BOOKVIEWURL = `https://apiview.katbook.com/v1`;
const BOOKVIEWURL1 = `https://apiview.katbook.com/v2`;

// const BOOKVIEWURL = `http://192.168.0.43:2507/v1`;
// const BOOKVIEWURL1 = `http://192.168.0.43:2507/v2`;

export async function getmedium() {
  const response = await fetch(`${URL}/variable/medium`, {
    method: `post`,
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}
export const getstandardbyMID = async (body, type) => {
  try {
    let apiUrl = `${URL}/variable/standard`;
    if (type === "teacher" || type === "student" || type === "parent") {
      apiUrl = `${URL}/variable/standard?type=groupby`;
    }
    const response = await fetch(apiUrl, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};
export const checkuserid = async (body) => {
  console.log(body, "testsce");
  try {
    const response = await fetch(`${URL}/user/userId/check?userId=${body}`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
    });
    if (response.status === 200) {
      return await response.json();
    } else if (response.status === 401 || response.status === 400) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};
export const createTeacher = async (body) => {
  try {
    const response = await fetch(`${URL}/user/teacher/add`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};
export const createStudent = async (body) => {
  try {
    const response = await fetch(`${URL}/user/student/add`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};
export const addStudentBook = async (userId, body) => {
  try {
    const response = await fetch(`${URL}/user/books/add/${userId}`, {
      method: `put`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};
export const createParent = async (body) => {
  try {
    const response = await fetch(`${URL}/user/parent/add`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};
export const useridsuggestion = async (body) => {
  try {
    const response = await fetch(`${URL}/user/name/suggestions`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (response.status === 401 || response.status === 400) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};
export async function getuseridDetails(body) {
  const response = await fetch(`${URL}/user/get?userId=${body}`, {
    method: `get`,
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}
export const userlogin = async (body) => {
  try {
    const response = await fetch(`${URL}/user/login`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};
export async function otpverfication(body) {
  const response = await fetch(
    `${URL}/user/otp/validate`,
    {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function otpgenerate(body) {
  let mobile = body.mobile;
  let type = body.type;
  let userid = body.userid;
  let role = body.role;
  let apiUrl = `${URL}/user/otp/send?mobile=${mobile}&type=${type}&role=${role}`;
  if (type === "reset" && userid !== null) {
    apiUrl = `${URL}/user/otp/send?userId=${userid}&type=${type}&role=${role}`;
  }
  const response = await fetch(apiUrl, {
    method: `post`,
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export const forgetpwd = async (body) => {
  try {
    const response = await fetch(`${URL}/user/password/reset`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};

export const getAllKatBookSubjects = async (body) => {
  const token = localStorage.getItem(`token`);
  try {
    const response = await fetch(`${URL}/variable/books/get`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};

export const getUserListFromUsers = async (body) => {
  try {
    const response = await fetch(`${URL}/user/getid`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};

export const postalPincode = async (body) => {
  console.log(body, "testsce");
  try {
    const response = await fetch(`${KpostApiUrl}/common/postalPinCode`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200 || response.status === 201) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 500
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};

export async function getNcretBookDetails() {
  const response = await fetch(`${URL}/variable/book-details`, {
    method: `get`,
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export const GetBookCountforAll = async (body) => {
  try {
    const response = await fetch(
      `${BOOKVIEWURL1}/student/book/analytics/book/${body?.studentId}/${body?.bookId}?instId=${body?.refInstID}&standardId=${body?.refStandardID}&subjectId=${body?.refSubjectID}`,
      {
        method: `GET`,
        headers: {
          "Content-Type": "application/json",
          // Authorization: token,
        },
        // body: JSON.stringify(body),
      }
    );
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};

export const GetUnitCountforAll = async (body) => {
  try {
    const response = await fetch(
      `${BOOKVIEWURL1}/student/book/analytics/unit/${body?.studentId}/${body?.unitId}?instId=${body?.refInstID}&standardId=${body?.refStandardID}&subjectId=${body?.refSubjectID}`,
      {
        method: `GET`,
        headers: {
          "Content-Type": "application/json",
          // Authorization: token,
        },
        // body: JSON.stringify(body),
      }
    );
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};

export const GetSessionCountforAll = async (body) => {
  try {
    const response = await fetch(
      `${BOOKVIEWURL1}/student/book/analytics/session/${body?.studentId}/${body?.sessionId}?instId=${body?.refInstID}&standardId=${body?.refStandardID}&subjectId=${body?.refSubjectID}`,
      {
        method: `GET`,
        headers: {
          "Content-Type": "application/json",
          // Authorization: token,
        },
        // body: JSON.stringify(body),
      }
    );
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};

export const GetBookUnitSessions = async (bookId) => {
  try {
    const response = await fetch(
      `${BOOKVIEWURL}/variables/unit-sessions/${bookId}`,
      {
        method: `GET`,
        headers: {
          "Content-Type": "application/json",
          // Authorization: token,
        },
        // body: JSON.stringify(body),
      }
    );
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};

export async function fetchFeedbackQuestions(className, userType) {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/feedback/questions?classname=${className}&usertype=${userType}`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export const feedbackSubmit = async (body) => {
  const token = localStorage.getItem(`token`);
  try {
    const response = await fetch(`${URL}/feedback/submit`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (response.status === 401 || response.status === 400) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};

export const addFeedback = async (body) => {
  try {
    const response = await fetch(`${URL}/feedback/site`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};
export const createAdmin = async (body) => {
  try {
    const response = await fetch(`${URL}/user/admin/add`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};

export async function getDashboardUserCount() {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/dashboard/users/count`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getStakeholdersTopCities() {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/dashboard/stakeholders/top-cities`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getStakeholdersTopStates() {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/dashboard/stakeholders/states`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getStatesDropdown() {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/states`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getcityDropdown(state) {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/cities?state=${state}`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getTableDataSuperAdmin() {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/dashboard/stakeholders/coverage-report`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getInstitutionName(search) {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/dashboard/institutions?search=${search}`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getInstitutionNameDashboard(state, city) {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/dashboard/institutions?state=${state}&city=${city}`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getcountriesbyPincode() {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/countries`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getStateName(country, search) {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/states?country=${country}&q=${search}`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getcityName(state, search) {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/cities?state=${state}&q=${search}`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getareaname(city, search) {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/areas?city=${city}&q=${search}`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export const getStandardbyInstitutionName = async (body) => {
  const token = localStorage.getItem(`token`);
  try {
    const response = await fetch(`${URL}/dashboard/standards`, {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json();
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    throw e;
  }
};

export async function getSubjectfordashboard(standard) {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/dashboard/subjects?standard=${standard}`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getDashboardTable(body) {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/dashboard/stakeholders/coverage-report`,
    {
      method: `post`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    });
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function GetUserListDashboard(state, city) {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/dashboard/download/users?state=${state}&city=${city}`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function reportGenerate() {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/dashboard/download/users`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}


export async function getAllCountries() {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/location/countries`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}


export async function otpgenerateforRegister(body) {
  let apiUrl = `${URL}/user/registration/verification`;
  const response = await fetch(apiUrl, {
    method: `post`,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function otpresetforUser(body) {
  let apiUrl = `${URL}/user/reset/verification`;
  const response = await fetch(apiUrl, {
    method: `post`,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}

export async function getFeedbackReport(classId, userType) {
  const token = localStorage.getItem(`token`);
  const response = await fetch(
    `${URL}/feedback/responses/groupby-questions?classId=${classId}&userType=${userType}`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}


export async function getAllSchoolNames(search) {
  const response = await fetch(
    `${URL}/institutions`,
    {
      method: `GET`,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  if (response.status === 200) {
    return await response.json();
  } else if (
    response.status === 401 ||
    response.status === 400 ||
    response.status === 404 ||
    response.status === 500
  ) {
    return await response.json();
  } else {
    let errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
}